import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { Grid, MenuItem, TextField } from '@material-ui/core';
import { watch } from 'fs';
import { DiscountEntity } from 'generated/graphql';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useForm, useWatch } from 'react-hook-form';
import NumberFormat from 'react-number-format';

const isOpenDiscountEnabled = (value: any): boolean =>
	value === true || value === 'true' || value === 1 || value === '1';

export const OrderItemDiscountDialog = (props: any) => {
	const {
		state,
		dispatch,
		register,
		control,
		handleSubmit,
		onSubmit,
		getFilteredDiscount,
		createdOrderItemDiscountLoading,
	} = props;

	const [selectDiscount,setSelectDiscount] = useState<DiscountEntity| null>(null);
	const discountCode = useWatch({
		control,
		name: "discountCode",
	})

	const discountAmount = useWatch({
		control,
		name:"discountAmount",
	})

	const [isOpenDiscountAmountOver,setIsOpenDiscountAmountOver] = useState(false);
	const resolvedDiscount = useMemo(
		() =>
			getFilteredDiscount?.find(
				(d: DiscountEntity) => String(d.ID) === String(discountCode),
			) ?? selectDiscount,
		[getFilteredDiscount, discountCode, selectDiscount],
	);
	const isOpenDiscount =
		isOpenDiscountEnabled(resolvedDiscount?.isOpenDiscount) ||
		String(resolvedDiscount?.code ?? '')
			.toLowerCase()
			.includes('open');

	const isOpenDiscountAmountInvalid = isOpenDiscount&&(
		!discountAmount|| Number(discountAmount)<=0||
		Number(discountAmount)> resolvedDiscount?.amount
	);

	useEffect(() => {
	if (!state?.OIDDialog) {
		setSelectDiscount(null);
		setIsOpenDiscountAmountOver(false);
	}
	}, [state?.OIDDialog]);

	useEffect(() => {
		if (!discountCode) {
			setSelectDiscount(null);
			return;
		}

		const selected = getFilteredDiscount?.find(
			(d: DiscountEntity) => String(d.ID) === String(discountCode)
		);
		setSelectDiscount(selected ?? null);
	}, [discountCode, getFilteredDiscount]);
	return (
		<>
			<CommonDialog
				fullWidth={true}
				open={state?.OIDDialog}
				onClose={() => dispatch({ type: 'OIDDialog', payload: false })}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">Item Discount</div>
									</div>
								</div>
								<div className="infoline-content ">
									<div className="xsTitle infoline">
										{state?.selectedOrderItem?.menuItem?.name}
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<div
								className="content-container "
								style={{ overflow: 'hidden' }}
							>
								<Controller
										render={({value,onChange})=>(
											<TextField
											select
											fullWidth
											label="Discount Code.*"
											value={value}
											onChange={(e) => {
											const id = e.target.value;
											console.log('id',id);
											
											onChange(id); // ✅ update RHF

											const selected = getFilteredDiscount?.find(
											d => String(d.ID) === String(id)
											);

											if (isOpenDiscountEnabled(selected?.isOpenDiscount)) {
												console.log("Selected Open-discount code:", selected.code);
												console.log("Selected isOpenDiscount", selected?.isOpenDiscount);
												
												setSelectDiscount(selected);
											}else{
												setSelectDiscount(null);
											}
											}}
											>
												{getFilteredDiscount?.map(x=>(
													<MenuItem key={x.ID} value={x.ID}>
														{x.code}
													</MenuItem>
												))}
												</TextField>
										)}
									// as={
									// 	<TextField name="discountCode" ref={register}>
									// 		{getFilteredDiscount?.map(x => (
									// 			<MenuItem key={x.ID} value={x.ID}>
									// 				{x.code}
									// 			</MenuItem>
									// 		))}
									// 	</TextField>
									// }
									name="discountCode"
									// margin="normal"
									// label="Discount Code.*"
									fullWidth
									autoComplete="off"
									multiline={true}
									select
									control={control}
									defaultValue=""
									ref={register}
									// style={{ paddingLeft: '5px' }}
								/>
							</div>
							{isOpenDiscount && (
								<>
								<div className="content-container">
									<Controller
										name='discountAmount'
										// margin="normal"
										label="Discount"			
										control={control}
										defaultValue="0.00"
										as={
											<NumberFormat
												customInput={TextField}
												allowNegative={false}
												fullWidth
												autoComplete='off'
												isNumericString
												decimalScale={
													2
												}
												value="0.00"
												fixedDecimalScale
												error={isOpenDiscountAmountOver}
												onValueChange={(value:any)=>{
													const {floatValue}=value;

													if (!floatValue) {
														setIsOpenDiscountAmountOver(false);
														return;
													}
													if (floatValue > resolvedDiscount?.amount) {
														console.log("Discount Amount is Exceeded");
														setIsOpenDiscountAmountOver(true);
														
													}else{
														setIsOpenDiscountAmountOver(false);
													}
												}}
											/>
										}
									/>
								</div>
								{isOpenDiscountAmountOver && (
									<div style={{color:'red',marginTop:4,padding:' 10px 0px'}}>
										Discount Amount is exceed
									</div>
								)}
								</>
							)}
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () =>
										dispatch({ type: 'OIDDialog', payload: false }),
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => handleSubmit(onSubmit)(),
									variant: 'contained',
									form: 'submitOID-form',
									color: createdOrderItemDiscountLoading
									|| !discountCode || isOpenDiscountAmountInvalid
										? 'inherit'
										: 'primary',
									disabled: createdOrderItemDiscountLoading 
									|| !discountCode || isOpenDiscountAmountInvalid
									? true : false,
									type: 'submit',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};

export const OrderDiscountDialog = (props: any) => {
	const {
		state,
		dispatch,
		register,
		control,
		handleSubmit,
		getFilteredDiscount,
		onSubmit,
		createdOrderDiscountLoading,
	} = props;

	const [selectDiscount,setSelectDiscount] = useState<DiscountEntity| null>(null);
	const discountCode = useWatch({
		control,
		name: "discountCode",
	})

	const discountAmount = useWatch({
		control,
		name:"discountAmount",
	})

	const [isOpenDiscountAmountOver,setIsOpenDiscountAmountOver] = useState(false);
	const resolvedDiscount = useMemo(
		() =>
			getFilteredDiscount?.find(
				(d: DiscountEntity) => String(d.ID) === String(discountCode),
			) ?? selectDiscount,
		[getFilteredDiscount, discountCode, selectDiscount],
	);
	const isOpenDiscount =
		isOpenDiscountEnabled(resolvedDiscount?.isOpenDiscount) ||
		String(resolvedDiscount?.code ?? '')
			.toLowerCase()
			.includes('open');

	const isOpenDiscountAmountInvalid = isOpenDiscount&&(
		!discountAmount|| Number(discountAmount)<=0||
		Number(discountAmount)> resolvedDiscount?.amount
	);

	useEffect(() => {
		if (!state?.ODDialog) {
			setSelectDiscount(null);
			setIsOpenDiscountAmountOver(false);
		}
	}, [state?.ODDialog]);

	useEffect(() => {
		if (!discountCode) {
			setSelectDiscount(null);
			return;
		}

		const selected = getFilteredDiscount?.find(
			(d: DiscountEntity) => String(d.ID) === String(discountCode)
		);
		setSelectDiscount(selected ?? null);
	}, [discountCode, getFilteredDiscount]);

	// const [,forceRender] = useState(0);
	// useEffect(() => {
	// const subscription = watch(() => {
	// 	forceRender(v => v + 1);
	// });

	// return () => subscription.unsubscribe();
	// }, [watch]);
	// // const {getValues }= useForm();
	// const discountID = getValues("discountCode");
	// const selectDiscount = useMemo(()=>{
		
	// 	return  getFilteredDiscount?.find(
	// 		d=> d.code === Number(discountID)
	// 	)
	// },[discountID,getFilteredDiscount]);

	// useEffect(()=>{
	// 	if (selectDiscount) {
	// 		console.log("Selected code:", selectDiscount.code);
			
	// 	}
	// },[selectDiscount])
	// console.log("RHF discountCode:", discountID);
	// console.log("Selected discount:", selectDiscount);
	return (
		<>
			<CommonDialog
				fullWidth={true}
				open={state?.ODDialog}
				onClose={() => {
					dispatch({ type: 'isButtonClicked', payload: false });
					dispatch({ type: 'ODDialog', payload: false });
				}}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">Order Discount</div>
									</div>
								</div>
								<div className="infoline-content ">
									<div className="xsTitle infoline">
										{state?.selectedOrder?.docNo}
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<div className="content-container">
								<Controller
									// as={
									// 	<TextField 
									// 	// name="discountCode" 
									// 	ref={register}
									// 	onChange={(e)=>{
									// 			const id = e.target.value;
									// 			console.log('id',id);
												
									// 			// onChange(id); // ✅ update RHF

									// 			const selected = getFilteredDiscount?.find(
									// 			d => d.ID === id
									// 			);

									// 			if (selected?.isOpenDiscount === true) {
									// 				console.log("Selected Open-discount code:", selected.code);
									// 				console.log("Selected isOpenDiscount", selected?.isOpenDiscount);
													
									// 				setSelectDiscount(selected);
													
									// 			}else{
									// 				setSelectDiscount(null);
									// 			}
									// 			// if (selected) {
									// 			// console.log("Selected code:", selected.code);
									// 			// setSelectDiscount(selected);
									// 			// }
									// 	}}
									// 	>
									// 		{getFilteredDiscount?.map(x => {
									// 			console.log("code",x.code);
												
									// 		return (	<MenuItem key={x.ID} value={x.ID}>
									// 				{x.code}
									// 			</MenuItem>
									// 		)
									// 		})}
											
									// 	</TextField>
									// }
									
									render={({ value, onChange }) => (
										<TextField
										select
										fullWidth
										label="Discount Code.*"
										value={value}   // ✅ REQUIRED
										onChange={(e) => {
											const id = e.target.value;
											console.log('id',id);
											onChange(id); // ✅ update RHF

											const selected = getFilteredDiscount?.find(
											d => String(d.ID) === String(id)
											);


											if (isOpenDiscountEnabled(selected?.isOpenDiscount)) {
												console.log("Selected Open-discount code:", selected.code);
												console.log("Selected isOpenDiscount", selected?.isOpenDiscount);
												
												setSelectDiscount(selected);
												
											}else{
												setSelectDiscount(null);
											}
											// if (selected) {
											// console.log("Selected code:", selected.code);
											// setSelectDiscount(selected);
											// }
										}}
										>
										{getFilteredDiscount?.map(x => (
											<MenuItem key={x.ID} value={x.ID}>
											{x.code}
											</MenuItem>
										))}
										</TextField>
									)}
									name="discountCode"
									// margin="normal"
									label="Discount Code.*"
									fullWidth
									autoComplete="off"
									multiline={true}
									select
									control={control}
									defaultValue=""
									ref={register}
								/>
							</div>
							{/* {getFilteredDiscount?.map(x=>{
								const selectedDiscountID = watch('discountCode');

								const selectedDiscount = getFilteredDiscount?.find(
									x=> x.ID === selectedDiscountID
								)

								{selectedDiscount?.isOpenDiscount === true && (
									<div className="content-container">
										
										<Controller
										as={
											<NumberFormat
												customInput={TextField}
												allowNegative={false}
												fullWidth
												autoComplete='off'
												isNumericString
												decimalScale={2}
												fixedDecimalScale
												onValueChange={(value:any)=>{
													const {floatValue}=value;
												}}
											/>
										}
										name='discountAmount'
										// margin="normal"
										label="Discount"			
										control={control}
										ref={register}
										/>
									</div>
								)}
								// if (x?.isOpenDiscount === true) {

								// 	return (
								// 	<div className="content-container">
										
								// 		<Controller
								// 		as={
								// 			<NumberFormat
								// 				customInput={TextField}
								// 				allowNegative={false}
								// 				fullWidth
								// 				autoComplete='off'
								// 				isNumericString
								// 				decimalScale={2}
								// 				fixedDecimalScale
								// 				onValueChange={(value:any)=>{
								// 					const {floatValue}=value;
								// 				}}
								// 			/>
								// 		}
								// 		name='isOpenDiscount'
								// 		// margin="normal"
								// 		label="Discount"			
								// 		control={control}
								// 		ref={register}
								// 		/>
								// 	</div>
								// 	)
								// }
							})
							} */}
							{isOpenDiscount && (
								<>
								<div className="content-container">
									<Controller
										name='discountAmount'
										// margin="normal"
										label="Discount"			
										control={control}
										defaultValue=""
										as={
											<NumberFormat
												customInput={TextField}
												allowNegative={false}
												fullWidth
												autoComplete='off'
												isNumericString
												decimalScale={2}
												fixedDecimalScale
												onValueChange={(value:any)=>{
													const {floatValue}=value;

													if (!floatValue) {
														setIsOpenDiscountAmountOver(false);
														return;
													}
													if (floatValue > resolvedDiscount?.amount) {
														console.log("Discount Amount is Exceeded");
														setIsOpenDiscountAmountOver(true);
														
													}else{
														setIsOpenDiscountAmountOver(false);
													}
												}}
											/>
										}
										/>
								</div>
								{isOpenDiscountAmountOver && (
									<div style={{color:'red',marginTop:4,padding:' 10px 0px'}}>
										Discount Amount is exceed
									</div>
								)}
								</>
							)}
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										dispatch({ type: 'isButtonClicked', payload: false });
										dispatch({ type: 'ODDialog', payload: false });
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										dispatch({ type: 'isButtonClicked', payload: true });
										handleSubmit(onSubmit)();
									},
									variant: 'contained',
									form: 'submitOD-form',
									color:
										createdOrderDiscountLoading || state?.isButtonClicked 
										|| !discountCode || isOpenDiscountAmountInvalid
											? 'inherit'
											: 'primary',
									disabled:
										createdOrderDiscountLoading || state?.isButtonClicked 
										// || watch("discountCode") === null|| watch("discountCode") === undefined
										|| !discountCode || isOpenDiscountAmountInvalid
											? true
											: false,
									type: 'submit',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};

export const VoidDialog = (props: any) => {
	const {
		state,
		dispatch,
		control,
		register,
		errors,
		watch,
		handleSubmit,
		getReason,
		onSubmitVoid,
		deleteOrderItemDiscountLoading,
		deleteOrderDiscountLoading,
	} = props;

	return (
		<>
			<CommonDialog
				fullWidth={true}
				open={state?.voidDialog}
				onClose={() => {
					dispatch({ type: 'isButtonClicked', payload: false });
					dispatch({ type: 'voidDialog', payload: false });
				}}
				sections={{
					header: {
						dynamic: (
							<div className="">
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="title">{`Void ${
											state?.selectedOrderItem?.ID
												? 'Item Discount'
												: 'Discount'
										}`}</div>
									</div>
								</div>
							</div>
						),
					},
					body: () => (
						<>
							<div className="mdDesc">
								<Grid container className="mdDesc">
									<Grid item xs={12} style={{ marginBlockStart: '10px' }}>
										<Controller
											as={
												<TextField select size="small" label="Reason">
													{getReason?.map((x, index) => (
														<MenuItem key={index} value={x?.name}>
															{x?.name}
														</MenuItem>
													))}
												</TextField>
											}
											name="reasonCode"
											autoComplete="off"
											control={control}
											ref={register}
											multiline
											fullWidth
											required
											margin="normal"
											helperText={errors?.reasonCode?.message}
											error={errors?.reasonCode ? true : false}
										></Controller>
									</Grid>
									<Grid item xs={12}>
										<Controller
											as={<TextField />}
											name="remark"
											label="Remark"
											autoComplete="off"
											control={control}
											ref={register}
											multiline
											required
											fullWidth
											margin="normal"
											helperText={errors?.remark?.message}
											error={errors?.remark ? true : false}
										></Controller>
									</Grid>
								</Grid>
							</div>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										dispatch({ type: 'isButtonClicked', payload: false });
										dispatch({ type: 'voidDialog', payload: false });
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										// Disable the button immediately
										dispatch({ type: 'isButtonClicked', payload: true });
										handleSubmit(onSubmitVoid)();
									},
									variant: 'contained',
									type: 'submit',
									color:
										watch('reasonCode') === undefined ||
										watch('reasonCode') === null ||
										watch('remark') === undefined ||
										watch('remark') === null ||
										watch('remark') === '' ||
										deleteOrderItemDiscountLoading ||
										deleteOrderDiscountLoading ||
										state?.isButtonClicked
											? 'inherit'
											: 'primary',
									disabled:
										watch('reasonCode') === undefined ||
										watch('reasonCode') === null ||
										watch('remark') === undefined ||
										watch('remark') === null ||
										watch('remark') === '' ||
										deleteOrderItemDiscountLoading ||
										deleteOrderDiscountLoading ||
										state?.isButtonClicked,
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
